import { getSecurityConfig, putSecurityConfig } from '@/api/account-center/account-security'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'

// 获取安全配置
export const useGetSecurityConfig = () => {
  const { data, runAsync: run } = useRequest(() => getSecurityConfig(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全配置失败'))
    },
  })

  return [run] as const
}

// 修改安全配置
export const useUpdateSecurityConfig = () => {
  const { loading, runAsync: run } = useRequest((data: any) => putSecurityConfig(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('修改安全配置失败'))
    },
  })
  return [loading, run] as const
}
